// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  attachmentId: __t.u64().primaryKey().name("attachment_id"),
  messageId: __t.u64().name("message_id"),
  kind: __t.string(),
  payloadJson: __t.string().name("payload_json"),
  createdAt: __t.i64().name("created_at"),
});
